<template>
  <section>
    <gs-header title="Thêm mới ngân hàng"
      :breadcrumbs="[
        {title: 'Quản lý ngân hàng', route: {name: 'bank'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form label-position="top" class="margin-top" :rules="rules" ref="create-bank-form" :model="localBank" label-width="150px" @submit.prevent.native="validatorBeforeSubmit">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localBank.name" placeholder="Tên"></el-input>
            </el-form-item>
            <el-form-item label="Tên rút gọn" prop="short_name">
              <el-input v-model="localBank.short_name" placeholder="Tên rút gọn"></el-input>
            </el-form-item>
            <el-form-item label="Url">
              <el-input v-model="localBank.url" placeholder="Url"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Logo">
              <el-upload
                class="avatar-uploader"
                :action="uploadLogoUrl"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="handleLogoUpload"
                :before-upload="beforeLogoUpload">
                <img v-if="logo.path" :src="logo.path" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="24">
            <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
import { head } from 'lodash'
import { newBank } from 'src/api/bank'
import bankMixin from './mixins'
export default {

  name: 'NewBank',
  mixins: [bankMixin],
  data () {
    return {

    }
  },
  methods: {
    validatorBeforeSubmit () {
      this.submitting = true
      this.$refs['create-bank-form'].validate((valid) => {
        if (valid) {
          this.toggleLoadding()
          this.changedData = false
          newBank(this.localBank).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Tạo mới ngân hàng thành công',
                  type: 'success'
                })
                this.reloadGsTableAfterRedirect({name: 'bank'}, 'banks')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thất bại',
                  body: 'Tạo ngân hàng thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// NewBank.vue?2fe5539c